import { GlobalEnumerationsAceBenutzerrolle } from '@/api/model-index';
import { ExtendedAuthenticationService } from '@/core/components/authentication/services/extended-authentication.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(protected authenticationService: ExtendedAuthenticationService, protected router: Router) { }

  canActivate() {
    if (this.authenticationService.CurrentUser?.benutzerrolle != GlobalEnumerationsAceBenutzerrolle.Administrator)
        return this.router.navigateByUrl('/overview');

    return true;
  }
}
